import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';

const Footer = () => {
    return null;
};

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
    const { currentUser } = state.user;
    const { isAuthenticated } = state.Auth;

    return {
          currentUser,
          isAuthenticated,
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Footer);
